<template>
  <div class="blog-home">
        <b-container fluid >
            <b-row class="mycontainer-main " >
                <b-col cols="12" md="4" class="pl-5 leftcontent" >
                    <h1>{{ $t('blog.title') }}</h1>
                    <h1 class="pageSubtitle"> / {{ $t('blog.desc') }} </h1>
                    <b-button squared variant="outline-dark" class="mt-3 shadow"  @click="goBack">{{ $t('common.goback') }} </b-button>   
                </b-col>

                <b-col cols="12" md="7" class="py-3">
                    <b-card-group deck>
                        <b-card 
                        v-for="(post,index) in postListing"
                        :key="post.slug + '_' + index"
                        class="shadow"
                        img-top
                        :img-src="post.featured_image"
                        
                        >                        
                            <b-card-title style="font-weight: bold; color: black; font-size: 1.3em" > {{ post.title }} </b-card-title>                          
                            <!-- <b-card-text class="small text-muted">{{post.published}}</b-card-text> -->
                            <b-card-text> {{ post.summary }} </b-card-text>
                            
                            <router-link :to="'/blog/' + post.slug"> 
                                <b-button squared variant="dark" size="md" class="align-self-end main-button shadow mt-2 ">{{ $t('common.view') }}</b-button>
                            </router-link>                

                        </b-card>
                    </b-card-group>
                </b-col> 
            </b-row>          
        </b-container>
  </div>
</template>

<script>
import _ from 'lodash';
import Butter from 'buttercms';
export const butter = Butter('c02e20211ec08fd909ab2e9e91553eb8d35e5cff');


  export default {
    name: 'Blog',
    data() {
      return {
        page_title: 'Blog',
        posts: []
      }
    },
    methods: {
      getPosts() {
        butter.post.list({
          page: 1,
          page_size: 10
        }).then(res => {
          this.posts = res.data.data
        })
      },
    goBack (){
      this.$router.go(-1)
    },

    },
    created() {
      this.getPosts()
    },
    computed: {
     locale(){
          return this.$i18n.locale
      },
      postListing: function() {
        return _.orderBy(this.posts, ['published'], ['desc'])
      }
    },
    mounted() { 
        // this.getData() 
    },
    watch: {
        // locale: function (newLocale, oldLocale) {
        //     this.getData()
        // }
    },
    
  }
</script>

<style scoped>
.mycontainer-main {
    min-height:  calc(90vh);
}
.leftcontent {
    padding-top: 30vh;
    padding-bottom: 10vh;
}
.card-img-top {
    width: 100%;
    height: 15rem;
    object-fit: cover;
}
 .card-text{
    font-size:0.9em;
    text-overflow: ellipsis;
    overflow: hidden;
}
.card-body {
  display: flex;
  flex-direction: column;
}

button.btn {
  margin-top: auto;
}
</style>




// WEBPACK FOOTER //
// src/pages/Blog.vue